import { HttpClient, HttpErrorResponse, HttpHeaders, } from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { AssessmentCriteria, GetSessionInput } from '../models/assessment-model';
import { SessionExpiredService } from './session-expired-service';
import { GeneratePdf } from '../models/generatepdf-model';
import { IAppConfig } from '../core/models/app-config.model';
import { AppConfig } from "../design/app";
import { IApiResponse } from '../core/models/api-response.model';
import { AssessmentResponse } from '../core/models/assessmentResponse.model';
import { TeamSnapshotResponse } from '../models/teamsnapshotResponse.model';
import { SessionList } from '../models/SessionList';
const urlsStartPoint = '';



@Injectable({
    providedIn: 'root'
})
export class AssessmentService {
    public sessionNameToRedirect: any = ""; //This is the variable for redirect from session search to assessment search
  private _appConfig: any;
    constructor(private http: HttpClient,
      private _sessionExpiredService: SessionExpiredService) {
      this._appConfig = AppConfig;
    }

    public getPDFBlob(uid: string | undefined, region: string) {
      const baseUrl = this._appConfig.assessment.mainAPIBaseUrl;
      const downloadPDF = this._appConfig.assessment.downloadPDF;
      const baselineId = 1;
      const url = `${baseUrl + downloadPDF}?uid=${uid}&baselineID=${baselineId}&region=${region}`;
      const headers = new HttpHeaders();

      return this.http.get(url, { headers: headers, responseType: "arraybuffer", observe: "response" }).pipe(map((response: any) => {
        const fileName = response?.headers?.get('filename');
        const blobObj = new Blob([response.body], { type: 'application/pdf' });
        return { blob: blobObj, fileName: fileName };
      }));
    }

    public sendtoGetPDf(url, filename) {
        const apiUrl: string = "/api/results/GetPDF?theURL=" + encodeURIComponent(url) + "&theFilename=" + filename;
        window.open(apiUrl);
    }

    public getExport(assessmentCriteria: AssessmentCriteria) {  
      const apiUrl: string = this._appConfig.assessment.baseUrl + this._appConfig.assessment.assessmentExport      
      const data = JSON.stringify(assessmentCriteria);

      return this.http.post(apiUrl, data, { responseType: 'arraybuffer' }).pipe(
        map(response => {
          this._sessionExpiredService.resetTimer();
          return new Uint8Array(response);
        }),
        catchError(this.handleError)
      );        
    }

    public getAssessmentData(assessmentCriteria: AssessmentCriteria): Observable<any> {
        if (assessmentCriteria.SessionData === 'f8c3cd1f-7532-466f-87ee-b9cbb47abf1b' || assessmentCriteria.SessionData === '7a034772-1b9d-45b3-b3c4-2b104006462f') {
            const apiUrl: string = '/api/WalkMe/AssessmentResults';
            const headers = new HttpHeaders();

            return this.http.get(apiUrl, { headers: headers }).pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
        } else {
          const apiUrl: string = this._appConfig.assessment.baseUrl + this._appConfig.assessment.getAssessmentData;      
            const headers = new HttpHeaders();

          return this.http.post<IApiResponse<AssessmentResponse[]>>(apiUrl, assessmentCriteria, { headers: headers }).pipe(            
            map(res => {
                return res.Data;
                }),
                catchError(this.handleError)
            );
        }
    }

    public getSessionToList(getSessionInput: GetSessionInput): Observable<SessionList> {
        const baseUrl = this._appConfig.assessment.baseUrl;
        const IsDeloitteDomain = this._appConfig.assessment.getSessionsList;
        const apiUrl = `${baseUrl + IsDeloitteDomain }`;
        const headers = new HttpHeaders();
        
        return this.http.post<IApiResponse<SessionList>>(apiUrl, getSessionInput, { headers: headers }).pipe(
            map(res => {
                return res.Data;
            }),
            catchError(this.handleError)
        );
    }


    public isdeloitteDomain(emailid): Observable<boolean> {
        const baseUrl = this._appConfig.session.baseUrl;
        const IsDeloitteDomain = this._appConfig.session.deloitteDomain;
        const apiUrl = `${baseUrl + IsDeloitteDomain + '?actionparameter=' + emailid }`;
    
        const headers = new HttpHeaders();
        
        return this.http.get<IApiResponse<boolean>>(apiUrl, { headers: headers }).pipe(
            map(res => {
                return res.Data;
            }),
            catchError(this.handleError)
        );
    }
    public isExisitingUser(emailid): Observable<boolean> {
        const baseUrl = this._appConfig.session.baseUrl;
        const IsUserExist = this._appConfig.session.isUserExist;
        const apiUrl = `${baseUrl + IsUserExist + '?actionparameter=' + emailid }`;
        const headers = new HttpHeaders();
        
        return this.http.get<IApiResponse<boolean>>(apiUrl, { headers: headers }).pipe(
            map(res => {
                return res.Data;
            }),
            catchError(this.handleError)
        );
    }


    public saveCopySession(assessmentID, gDestID, region): Observable<any> {
        const baseUrl = this._appConfig.assessment.baseUrl;
        const IsUserExist = this._appConfig.assessment.copyFromAssessment;
        const apiUrl = `${baseUrl + IsUserExist + '?assessmentID=' + assessmentID + "&gDestID=" + gDestID + "&region=" + region }`;
        const headers = new HttpHeaders();
        
        return this.http.post(apiUrl,null, { headers: headers }).pipe(
            map(res => {
                return res;
            }),
            catchError(this.handleError)
        );
    }

    public saveEmailId(oldEmail, newEmail, region): Observable<any> {
        const baseUrl = this._appConfig.assessment.baseUrl;
        const updateEmail = this._appConfig.assessment.updateEmail;
        const apiUrl = `${baseUrl + updateEmail + '?oldEmail=' + oldEmail + "&newEmail=" + newEmail + "&region=" + region }`;
        const headers = new HttpHeaders();
        
        return this.http.post<IApiResponse<void>>(apiUrl,{},{ headers: headers }).pipe(
            map(res => {
                return res.Success;
            }),
            catchError(this.handleError)
        );
    }
  private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            console.error('An error occurred:', error.error.message);
        } else {
            console.error(
                `Backend returned code ${error.status}, ` +
                `body was: ${error.error}`);
        }
        return throwError(
            'Something bad happened; please try again later.');
    };

  public getTeamSnapshotDataUsingUID(payload): Observable<TeamSnapshotResponse> {
    const apiUrl: string = this._appConfig.assessment.mainAPIBaseUrl + this._appConfig.assessment.getTeamSnapshotDataUsingUID;
    const headers = new HttpHeaders();
    return this.http.post<TeamSnapshotResponse>(apiUrl, payload, { headers: headers });
  }

    public sendtoGetPDf_v2(url, filename) { 
        const apiUrl: string = "/api/results/GetPDf?theURL=" + encodeURIComponent(url) + "&theFileName=" + filename;
        window.open(apiUrl);
    }


  public downloadTeamSnapshotReport(uid: string, language: string, baselineID: number, fileName: string) {
    const baseUrl = this._appConfig.assessment.mainAPIBaseUrl;
    const downloadTeamSnapshotPDF = this._appConfig.assessment.downloadTeamSnapshotPDF;
    const url = `${baseUrl + downloadTeamSnapshotPDF + '?uid=' + uid + '&lang=' + language + '&baseline=' + baselineID}`;

    return this.http.get(url, { responseType: 'blob' });
  }

  public sendtoPostPDf(generatePdf: GeneratePdf) {
    const apiUrl: string = this._appConfig.assessment.mainAPIBaseUrl + this._appConfig.assessment.savePDFSerach;      
    const headers = new HttpHeaders();
   
    console.log("generatepdf:" + JSON.stringify(generatePdf.SelectedIds));
    return this.http.post(apiUrl, generatePdf, { headers: headers, responseType:'text' }).pipe(
      map(res => {
        console.log(res);
        return res;
            }),
            catchError(this.handleError)
        );
    }
}
